import BigNumber from 'bignumber.js';

import { VBep20, VBnbToken, UmiToken, UmiVault, DlVault } from 'types/contracts';

export interface GetRoiInput {
  dlVaultContract: DlVault;
  accountAddress: string;

}

export type GetRoiOutput = {
  inviter: string;
};

const getRoi = async ({
  dlVaultContract,
                               accountAddress,
}: GetRoiInput): Promise<GetRoiOutput> => {
  const res = await dlVaultContract.methods.roi().call();

  return {
    inviter: res,
  };
};

export default getRoi;
